import { formatPercentage } from 'shared/src/domain/line-item/line-item-utils';

export function equalToTwoDecimalPlaces(
  value1: number | null | undefined,
  value2: number | null | undefined
): boolean {
  if (value1 == null) {
    return value2 == null;
  } else if (value2 == null) {
    return false;
  }
  if (isNaN(value1)) {
    return isNaN(value2);
  } else if (isNaN(value2)) {
    return false;
  }
  return Math.round(value1 * 100) === Math.round(value2 * 100);
}

export function equalRoundedToInt(
  value1: number | null | undefined,
  value2: number | null | undefined
): boolean {
  if (value1 == null) {
    return value2 == null;
  } else if (value2 == null) {
    return false;
  }
  if (isNaN(value1)) {
    return isNaN(value2);
  } else if (isNaN(value2)) {
    return false;
  }
  return Math.round(value1) === Math.round(value2);
}

export function formatPct(value: number | null | undefined) {
  if (value == null) return '-';
  return formatPercentage(value, 2);
}

export function round2(n: number): number {
  return Math.round(n * 100) / 100;
}
